<template>
  <div class="provider-info">
    <span class="provider-name">
      Mozio
    </span>
    <provider-category
      v-if="category"
      :category="category"
    />
  </div>
</template>

<script>

import ProviderCategory from './ProviderCategory';

export default {
  name: 'ProviderInfo',
  components: {
    ProviderCategory,
  },
  props: {
    category: {
      type: Object,
      default: () => ({
        name: '',
        id: '',
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
  .provider-name {
    font-family: Rubik;
    font-size: 30px;
    font-weight: 500;
    line-height: 1;
    color: #444;
    display: inline-block;
    margin-right: 10px;
  }
</style>
